export default "__VITE_ASSET__49a6aeb7__"